import { render, staticRenderFns } from "./informationCommodities.vue?vue&type=template&id=2a9714b8&"
import script from "./informationCommodities.vue?vue&type=script&lang=js&"
export * from "./informationCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports